import {
  SOCIAL_MEDIA_CONTENT_TYPE_REEL,
  SOCIAL_POST_STATUS_DRAFT,
  SOCIAL_POST_STATUS_FAILED,
  SOCIAL_POST_STATUS_PUBLISHED,
  SocialMediaContent,
  SocialMediaPost,
} from '../../types';
import {
  SOCIAL_MEDIA_ASSET_FACEBOOK_PAGE,
  SOCIAL_MEDIA_ASSET_INSTAGRAM_ACCOUNT,
} from '../../../social-posting/socialPostingApi';
import { isUnscheduled } from '../../unscheduledProgramUtil';
import moment from 'moment/moment';

export const getAggregatePostStatus = (
  content: SocialMediaContent,
  publishOn: Date,
  posts: SocialMediaPost[]
): { status: 'ERROR' | 'SUCCESS' | 'UNSCHEDULED' | 'PENDING'; description: string } => {
  const dateTimeFormat = 'MMM DD, h:mm A';
  return posts.length === 0
    ? { status: 'UNSCHEDULED', description: 'Not selected for publishing' }
    : posts.find((x) => x.status === SOCIAL_POST_STATUS_FAILED)
    ? { status: 'ERROR', description: 'Failed to publish.' }
    : posts.find(
        (x) =>
          x.status === SOCIAL_POST_STATUS_DRAFT &&
          x.type === SOCIAL_MEDIA_ASSET_FACEBOOK_PAGE &&
          !content?.attachments.length &&
          !content?.text
      )
    ? {
        status: 'UNSCHEDULED',
        description:
          content.type === SOCIAL_MEDIA_CONTENT_TYPE_REEL
            ? 'Add video'
            : 'Add image, video or text',
      }
    : posts.find(
        (x) =>
          x.status === SOCIAL_POST_STATUS_DRAFT &&
          x.type === SOCIAL_MEDIA_ASSET_INSTAGRAM_ACCOUNT &&
          !content?.attachments.length
      )
    ? {
        status: 'UNSCHEDULED',
        description:
          content.type === SOCIAL_MEDIA_CONTENT_TYPE_REEL ? 'Add video' : 'Add image or video',
      }
    : posts.find((x) => x.status === SOCIAL_POST_STATUS_PUBLISHED)
    ? {
        status: 'SUCCESS',
        description: `Published ${
          posts.length === 1 && posts[0].publishing?.publishedDateTime
            ? moment(posts[0].publishing?.publishedDateTime).format(dateTimeFormat)
            : ''
        }`,
      }
    : isUnscheduled({ startDateTime: publishOn })
    ? { status: 'UNSCHEDULED', description: 'Unscheduled' }
    : publishOn < moment().subtract(24, 'hours').toDate()
    ? { status: 'ERROR', description: 'Publish date is in the past' }
    : { status: 'PENDING', description: `Scheduled ${moment(publishOn).format(dateTimeFormat)}` };
};
